import { createDraftSafeSelector } from "@reduxjs/toolkit";

import { RootState } from "../../../store-types";
import { ICropsState } from "../shared";

import { CROPS_MODULE_NAME } from "./constants";

export const getCropsState = (rootState: RootState): ICropsState =>
  rootState[CROPS_MODULE_NAME];

export const getSelectedIds = createDraftSafeSelector(
  getCropsState,
  (state: ICropsState) => state.selectedIds
);

export const getSearchText = createDraftSafeSelector(
  getCropsState,
  (state: ICropsState) => state.searchText
);
